import React from 'react'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import ComponentUnmounter from 'aria-viewer/utils/componentUnmounter'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'

const styleSheet = {
    container: ({ style, delay = styleguide.delay.normal, test }) => ({
        WebkitBackfaceVisibility: 'hidden',
        transition: `visibility ${delay}, opacity ${delay}`,
        visibility: test ? 'visible' : 'hidden',
        opacity: test ? 1 : 0,
        ...style,
    }),
}

const style = injectSheet(styleSheet)

const OpacityHelper = ({ classes, test, onMouseEnter, onClick, ignoreUnmount, children, onUnMounted }) => (
    <div className={classes.container} onMouseEnter={onMouseEnter} onClick={onClick}>
        <ComponentUnmounter onUnMounted={onUnMounted} visible={test || ignoreUnmount}>
            {children}
        </ComponentUnmounter>
    </div>
)

export default compose(style)(OpacityHelper)
